module.exports = __webpack_public_path__ + "media/logos/pymnts-logo-white-a1f8f0a5.png";